export const REPLY_EDITOR_MODES = {
  REPLY: 'REPLY',
  NOTE: 'NOTE',
  TRANSLATE: 'TRANSLATE',
};

// Al activar el modo Traducción solo se traducen los últimos N mensajes de la
// conversación (evita ráfagas de cientos de peticiones en hilos largos).
export const TRANSLATE_HISTORY_LIMIT = 30;

// Idiomas destino del modo Traducción (código que entiende el traductor).
export const TRANSLATE_LANGUAGES = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español' },
  { value: 'fr', label: 'Français' },
  { value: 'pt', label: 'Português' },
  { value: 'it', label: 'Italiano' },
  { value: 'de', label: 'Deutsch' },
  { value: 'ar', label: 'العربية' },
  { value: 'zh-CN', label: '中文' },
  { value: 'ru', label: 'Русский' },
  { value: 'ja', label: '日本語' },
];

export const CHAR_LENGTH_WARNING = {
  UNDER_50: 'characters remaining',
  NEGATIVE: 'characters over',
};
